import script from "./ExamTestQuestionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTestQuestionList.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTestQuestionList.vue?vue&type=style&index=0&id=b3e99894&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e99894"]])

export default __exports__